/**
 * @file Login screen — STRV logo + Google sign-in button.
 *
 * Every verified @strv.com account passes the gate. What they see after
 * sign-in is decided by isAdmin() in main.js + the Firestore rules.
 */

import { el, clear }    from './utils.js';
import { svgFromMarkup } from './lib/svg.js';
import { strvLogo }     from './logo.js';
import { signInWithGoogle, emulatorSignIn } from './auth.js';

export function renderLogin(host) {
  clear(host);

  // Emulator-only: `?emu-login=<email>` signs in with the harness password so
  // the headless screenshot run (scripts/mobile-harness) never needs the
  // Google popup. Vite inlines VITE_USE_EMULATORS at build time, so this
  // whole branch is dead code in the production bundle.
  if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    const email = new URLSearchParams(location.search).get('emu-login');
    if (email) emulatorSignIn(email).catch((err) => console.error('[login] emulator sign-in failed', err));
  }

  const errorBox = el('div', { class: 'login-error', hidden: true });

  const button = el('button', {
    class: 'btn-google',
    onClick: async () => {
      errorBox.hidden = true;
      try {
        await signInWithGoogle();
        // onAuth listener in main.js handles re-render.
      } catch (err) {
        errorBox.hidden = false;
        errorBox.textContent = err.message || 'Sign-in failed.';
      }
    },
  },
  // Single-colour G mark (per design spec).
  el('span', null, svgFromMarkup(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4c-.2 1.3-1 2.4-2 3.1v2.6h3.3c1.9-1.8 3-4.4 3-7.5zM12 22c2.7 0 5-1 6.6-2.6l-3.3-2.6c-.9.6-2 1-3.3 1-2.5 0-4.7-1.7-5.5-4H3.2v2.5C4.8 19.6 8.1 22 12 22zM6.5 13.7c-.2-.6-.3-1.2-.3-1.8 0-.6.1-1.2.3-1.8V7.6H3.2A10 10 0 0 0 2 12c0 1.6.4 3.1 1.2 4.4l3.3-2.7zM12 6.4c1.4 0 2.7.5 3.7 1.4L18.6 5C16.9 3.4 14.7 2.5 12 2.5 8.1 2.5 4.8 4.8 3.2 8.2l3.3 2.5c.8-2.3 3-4.3 5.5-4.3z"/>
    </svg>`)),
  'Sign in with Google');

  const shell = el('div', { class: 'login-shell' },
    el('a', { class: 'logo', href: 'https://strv.com', 'aria-label': 'STRV' }, strvLogo()),
    el('div', { class: 'login-box' },
      el('h1', null, 'Gear'),
      el('p', null, 'Sign in with your STRV Google account.'),
      button,
      errorBox,
    ),
  );

  host.appendChild(shell);
}
